import { useEffect, useState } from "react";
import {
  Button,
  OverlayTrigger,
  Spinner,
  Table,
  Tooltip,
} from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import Swal from "sweetalert2";
import frymesOrderApi from "../../../api/frymeOrderApi";
import Pagination from "../../../components/Pagination";
const PendingRequests = ({ email }) => {
  const [pendingRequests, setPendingRequests] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState({
    id: null,
    action: null,
  });
  console.log(email);

  useEffect(() => {
    fetchPendingRequests();
  }, [email, page, pageSize, sortedColumn, sortOrder]);

  const fetchPendingRequests = async () => {
    try {
      const response = await frymesOrderApi.getRequestsOfFA1(
        email,
        "PENDING",
        page,
        pageSize,
        sortedColumn,
        sortOrder,
      );

      setPendingRequests(response?.data?.content || []);
      setTotalPages(response?.data?.totalPages || 0);
    } catch (error) {
      console.error("Error fetching pending requests:", error);
      setPendingRequests([]);
      setTotalPages(0);
    }
  };
  console.log(pendingRequests);

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value, 10);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));

    setPage(selectedPage);
    localStorage.setItem("userCreditListAdmin", selectedPage);
  };

  const handleApprove = async (pricing) => {
   setLoading({
  id: pricing.id,
  action: "approve",
});

    try {
      await frymesOrderApi.approveRequest(pricing.id);

      Swal.fire({
        icon: "success",
        title: "Approved!",
        text: "Request approved successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      setPendingRequests((prev) =>
        prev.filter((item) => item.id !== pricing.id),
      );

      fetchPendingRequests();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Approval Failed!",
        text: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading({
        id: null,
        action: null,
      });
    }
  };

  const handleReject = async (request) => {
    setLoading({
      id: request.id,
      action: "reject",
    });

      try {
        await frymesOrderApi.rejectRequest(request.id);

      Swal.fire({
        icon: "success",
        title: "Rejected!",
        text: "Request rejected successfully",
        timer: 2000,
        showConfirmButton: false,
      });

      setPendingRequests((prev) =>
        prev.filter((item) => item.id !== request.id),
      );

      fetchPendingRequests();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Failed to reject request",
      });
    } finally {
      setLoading({
        id: null,
        action: null,
      });
    }
  };
  return (
    <>
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Fryme Type</th>
            <th>Buyer Details</th>
            <th>Quantity</th>
            <th>Unit Price</th>
            <th>Total Amount</th>
            <th>Requested At</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {pendingRequests.length > 0 ? (
            pendingRequests.map((pricing, index) => (
              <tr key={pricing.id || index}>
                {/* <td>{page * pageSize + index + 1}</td> */}

                <td>{pricing.id}</td>
                <td>{pricing.frymeType || "-"}</td>

                {/* BUYER DETAILS */}
                <td>
                  {pricing.buyer ? (
                    <>
                      <strong>Franchise</strong>
                      <br />
                      <small>{pricing.buyer?.organization || "-"}</small>
                      <br />
                      <small>{pricing.buyer?.location || "-"}</small>
                      <br />
                      <small>{pricing.buyer?.email || "-"}</small>
                    </>
                  ) : (
                    <>
                      <strong>Customer</strong>
                      <br />
                      <small>{pricing.customerName || "Customer"}</small>
                      <br />

                      {/* Show company details if available */}
                      {pricing.companyDetails ? (
                        <>
                          <small>
                            {pricing.companyDetails?.companyName || "-"}
                          </small>
                          <br />
                          <small>
                            {pricing.companyDetails?.location || "-"}
                          </small>
                        </>
                      ) : (
                        <small>{pricing.customerEmail || "-"}</small>
                      )}
                    </>
                  )}
                </td>

                <td>{pricing.quantity || "-"}</td>

                <td>
                  {pricing.unitPrice} {pricing.currencySymbol} (
                  {pricing.currencyCode})
                </td>

                <td>
                  {pricing.totalAmount} {pricing.currencySymbol} (
                  {pricing.currencyCode})
                </td>

                <td>{pricing.createdAt || "-"}</td>

                <td className="d-flex gap-2">
                  {/* APPROVE */}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="approve-tooltip">Approve</Tooltip>}
                  >
                    <Button
                      variant="success"
                      size="sm"
                      disabled={loading.id === pricing.id && loading.action === "approve"}
                      onClick={() => handleApprove(pricing)}
                    >
                      {loading.id === pricing.id && loading.action === "approve" ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <FaCheck />
                      )}
                    </Button>
                  </OverlayTrigger>

                  {/* REJECT */}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="reject-tooltip">Reject</Tooltip>}
                  >
                    <Button
                      variant="danger"
                      size="sm"
                      disabled={loading.id === pricing.id && loading.action === "reject"}
                      onClick={() => handleReject(pricing)}
                    >
                      {loading.id === pricing.id && loading.action === "reject" ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        <FaTimes />
                      )}
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center">
                No Pending Requests Found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <div style={{ marginTop: "auto" }}>
        {pendingRequests.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
    </>
  );
};

export default PendingRequests;
